import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflow: 'hidden',
  },
  progress: {
    margin: theme.spacing(2),
  },
}))

const LoadingSpinner = () => {
  const classes = useStyles()
  const load = useSelector(({ loadSpinner }) => loadSpinner)

  return (
    <div>
      <Dialog
        open={load.isLoading}
        {...classes}
        BackdropProps={{
          classes: {
            root: classes.root,
          },
        }}
        PaperProps={{
          classes: {
            root: classes.paper,
          },
        }}
      >
        <CircularProgress color="secondary" className={classes.progress} />
      </Dialog>
    </div>
  )
}

export default LoadingSpinner
